import { Stage } from "../enum/enums";

// TODO: change with beta and prod api gw endpoints when available
export const getStageBasedEASEEndpoint = (stage: Stage) => {
  switch (stage) {
    case Stage.alpha:
      return "https://5zdn6sydak.execute-api.us-west-2.amazonaws.com/prod";
    case Stage.beta:
      return "https://763f5quz9d.execute-api.us-west-2.amazonaws.com/prod";
    case Stage.prod:
      return "https://66w6rfqvka.execute-api.us-west-2.amazonaws.com/prod";
    default:
      return "https://5zdn6sydak.execute-api.us-west-2.amazonaws.com/prod";
  }
}

export const getStageBasedSSEndpoint = (stage: Stage) => {
  switch (stage) {
    case Stage.alpha:
      return "https://patdtonhf7.execute-api.us-west-2.amazonaws.com/prod";
    case Stage.beta:
      return "https://xxwqte5m9h.execute-api.us-west-2.amazonaws.com/prod";
    case Stage.prod:
      return "https://kg02wrvap8.execute-api.us-west-2.amazonaws.com/prod";
    default:
      return "https://patdtonhf7.execute-api.us-west-2.amazonaws.com/prod";
  }
}

export const getStageBasedAssetManagementServiceEndpoint = (stage: Stage) => {
  switch (stage) {
    case Stage.prod:
      return "https://3ypf554l6h.execute-api.us-west-2.amazonaws.com/prod";
    case Stage.alpha:
    case Stage.beta:
    default:
      return "https://wehkpbspgc.execute-api.us-west-2.amazonaws.com/beta";
  }
}

export const getStageBasedAssetCloudfrontDistribution = (stage: Stage) => {
  switch (stage) {
    case Stage.prod:
      return "https://dvcs52hch3qmk.cloudfront.net";
    case Stage.alpha:
    case Stage.beta:
    default:
      return "https://dk4blcbefh8nq.cloudfront.net";
  }
}
